export const ROUTES = {
  // Auth routes
  LOGIN: "/login",
  SIGN_UP: "/sign-up",
  FORGOT_PASSWORD: "/forgot-password",
  RESET_PASSWORD: "/reset-password",
  RESEND_INVITATION_SUCCESS: "/resend-invitation-success",

  // Population routes
  POPULATION: {
    ROOT: "/population",
    ADD_PATIENT: "/population/add-new-patient",
    PATIENT_DETAIL: "/population/patients/:bloomlifeId",
    PATIENT_READINGS:
      "/population/patients/:bloomlifeId/readings/:prescriptionId",
  },

  // Support routes
  SUPPORT: {
    ROOT: "/support",
    ADD_PATIENT: "/support/add-new-patient",
    PATIENT_DETAIL: "/support/patients/:bloomlifeId",
  },
} as const

/**
 * Build a path by replacing dynamic segments with actual values
 * @example buildPath(ROUTES.POPULATION.PATIENT_DETAIL, { bloomlifeId: "ABC123" })
 */
export const buildPath = (
  pattern: string,
  params: Record<string, string>
): string => {
  let path = pattern
  Object.entries(params).forEach(([key, value]) => {
    path = path.replace(`:${key}`, value)
  })
  return path
}

/**
 * Build a query string and append it to a path
 * @example withQuery("/population", { protocol: "diabetes" })
 */
export const withQuery = (path: string, params: Record<string, string>) => {
  const query = new URLSearchParams(params).toString()
  return query ? `${path}?${query}` : path
}
